
    import { computed, defineComponent, onBeforeMount, onServerPrefetch, ref } from 'vue'

    import SimplePage from '@/app/components/SimplePage.vue'
    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useVoiceBankStore } from '@/app/stores/voice-bank'

    import SimpleAudioPlayer from '@/common/components/SimpleAudioPlayer.vue'
    import { useSimplePlayersSet } from '@/common/composables/simple-players-set'
    import { useI18n } from 'vue-i18n-composable'
    import { voiceBankEntry } from '@/common/json-ld/media'
    import type { VoiceBankEntry } from '@/common/models/data/dashboard/voice-bank/voice-bank-entry'

    export default defineComponent({
        components: {
            SimpleAudioPlayer,
            SimplePage
        },
        setup () {
            const i18n = useI18n()
            const voiceBankStore = useVoiceBankStore()

            const filters = ref({
                sex: [] as Array<boolean>,
                type: [] as Array<number>,
                lang: [] as Array<number>
            })

            const types = computed(() => voiceBankStore.types)
            const languages = computed(() => voiceBankStore.languages)
            const entries = computed((): Array<VoiceBankEntry> => {
                return voiceBankStore.filteredEntries(
                    filters.value.sex,
                    filters.value.type,
                    filters.value.lang
                )
            })

            const initFilters = (): void => {
                filters.value.sex = [true, false]
                filters.value.type = voiceBankStore.types.map(type => type.id)
                filters.value.lang = voiceBankStore.languages.map(lang => lang.id)
            }

            onServerPrefetch((): void => initFilters())

            onBeforeMount(async (): Promise<void> => {
                // Fix for SSR not mismatch on client and server side
                // If Vue is trying to hydrate components, filters need to be initialized
                // and store data will be initialized here because of passed context
                initFilters()

                useBreadcrumbsStore().set([
                    { text: i18n.t('nav.offer.offer').toString(), to: { name: 'voice-bank' } },
                    { text: i18n.t('nav.offer.voice-bank').toString() }
                ])

                await voiceBankStore.load()

                initFilters()
            })

            return {
                ...useSimplePlayersSet(),
                entries,
                filters,
                jsonLd: voiceBankEntry,
                languages,
                types
            }
        }
    })
